// Tras guardar un formulario (crear/editar), vuelve a la lista QUITANDO el
// formulario del historial: así la flecha "atrás" del navegador no lleva otra vez
// al formulario. Si se entró directamente al formulario (sin página anterior en
// la app), sustituye la entrada por la lista.
// mensaje: texto de éxito opcional que la lista puede leer con leerMensajeGuardado().
const CLAVE = "mensaje_guardado";

export function volverTrasGuardar(navigate, rutaLista, mensaje) {
  if (mensaje) {
    try { sessionStorage.setItem(CLAVE, JSON.stringify({ ruta: rutaLista, mensaje })); } catch (_) {}
  }
  const idx = window.history.state && window.history.state.idx;
  if (typeof idx === "number" && idx > 0) navigate(-1);
  else navigate(rutaLista, { replace: true });
}

export function leerMensajeGuardado(rutaLista) {
  try {
    const raw = sessionStorage.getItem(CLAVE);
    if (!raw) return null;
    const { ruta, mensaje } = JSON.parse(raw);
    if (ruta !== rutaLista) return null;
    sessionStorage.removeItem(CLAVE);
    return mensaje;
  } catch (_) {
    return null;
  }
}
